// extracted by mini-css-extract-plugin
export default {"root":"ResultList-root_Q4Iqy","title":"ResultList-title_acU6M","rows":"ResultList-rows_KBMlt"};